export default {
  expired_title: 'Link expirado ou revogado',
  expired_body: 'Este link de compartilhamento não está mais ativo. Peça um novo a quem compartilhou.',
  expired_short: 'Este link expirou.',
  seen: 'Visto {time}',
  ago_now: 'agora mesmo',
  ago_min: 'há {count} min',
  ago_h: 'há {count} h',
  valid_min: 'Link válido por mais {count} min',
  valid_hm: 'Link válido por mais {h}h{m}min',
  valid_h: 'Link válido por mais {h}h',
  no_position: 'Ainda não há posição registrada para este dispositivo.',
  refresh_note: 'atualiza a cada 30 s',
  location_fallback: 'Localização',
  active: 'Ativo',
  map_tile_error: 'Não foi possível carregar parte do mapa.',
  map_error: 'Não foi possível carregar o mapa.',
}
